import React from 'react'
import CourseLandingPage from '../../components/Courses/CourseLandingPage/CourseLandingPage'
import AutodeskInventorCourse from '../../data/cad_section/AutodeskInventorCourse'
import SEO from '../../components/common/seo/SEO'

function InventorAPIPage() {
    return (
        <>
         <SEO
        title="Autodesk Inventor API Customization & Automation Training | Inventor API Course | FeesWorth"

        description="Learn Autodesk Inventor API customization and automation using C# and .NET. Master Inventor API, CAD automation, add-in development, part and assembly automation, drawing automation, and practical projects with expert training at FeesWorth."

        keywords="Inventor API Training, Inventor API Course, Autodesk Inventor API, Inventor Customization Training, Inventor Automation Training, Inventor C# Training, Inventor .NET API, Inventor Add-in Development, Inventor Automation Course, Inventor Programming"

        canonical="https://feesworth.com/autodesk-inventor-api-customization-automation-course"
      />
        
        <CourseLandingPage course={AutodeskInventorCourse} />
        
        </>

    )
}

export default InventorAPIPage